export interface LatLngValue {
  lat?: number;
  lng?: number;
  latitude?: number;
  longitude?: number;
}

export interface NormalizedLatLng {
  latitude: number;
  longitude: number;
}

export const unwrapLatLng = (val: LatLngValue | null | undefined): NormalizedLatLng => {
  if (!val) return { latitude: NaN, longitude: NaN };
  
  if (typeof val.lat === 'number' && typeof val.lng === 'number') {
    return { latitude: val.lat, longitude: val.lng };
  }
  
  if ('latitude' in val && 'longitude' in val) {
    return { latitude: Number(val.latitude), longitude: Number(val.longitude) };
  }
  
  return { latitude: NaN, longitude: NaN };
};

export const safeCenterFrom = (val: LatLngValue | null | undefined): [number, number] | null => {
  const { latitude, longitude } = unwrapLatLng(val);
  if (Number.isFinite(latitude) && Number.isFinite(longitude)) {
    return [longitude, latitude];
  }
  return null;
};
export const areValidCoordinates = (coords: NormalizedLatLng): boolean => {
  return Number.isFinite(coords.latitude) && Number.isFinite(coords.longitude);
};

export const boundsFromFeatures = (features: any[]): [[number, number], [number, number]] => {
  let minLon = Infinity,
    minLat = Infinity,
    maxLon = -Infinity,
    maxLat = -Infinity;
    
  for (const f of features) {
    const [lon, lat] = f.geometry.coordinates as [number, number];
    if (lon < minLon) minLon = lon;
    if (lon > maxLon) maxLon = lon;
    if (lat < minLat) minLat = lat;
    if (lat > maxLat) maxLat = lat;
  }
  
  return [
    [minLon, minLat],
    [maxLon, maxLat],
  ];
};